<template>
  <div class="welcome">
    <div class="container py-4">
      <div class="row align-items-center">
        <div class="col-12 col-md-6">
          <div class="welcome__text">
            <p class="first">
              Вітаємо Вас у системі
              <strong> Кадрового Резерву КШДУ ім. Сергія Нижного.</strong>
            </p>
            <p>
              Після реєстрації Ви матимете можливість відслідковувати вакансії
              державного сектору, подавати свою кандидатуру та пройти тестування
              для підготовки до співбесіди.
            </p>
          </div>
        </div>
        <div class="col-12 col-md-6"></div>
        <div class="col-12 col-md-6">
          <b-card>
            <b-overlay
              :show="isLoading"
              variant="white"
              spinner-variant="primary"
            >
              <div class="welcome__step-info" v-if="step != 'success'">
                Крок {{ currentStepIndex + 1 }} із {{ steps.length }}
              </div>
              <h3 class="mb-4" v-if="currentStep && currentStep.title">
                {{ currentStep.title }}
              </h3>

              <stepOne
                v-show="step == 'name'"
                @validate="checkStep"
                ref="name"
              />

              <stepTwo
                v-show="step == 'credentials'"
                @validate="checkStep"
                ref="credentials"
              />

              <stepThree v-show="step == 'success'" />

              <hr style="opacity: 0.1" v-if="step != 'success'" />
              <div
                class="form-input d-flex justify-content-end"
                v-if="step != 'success'"
              >
                <b-button
                  v-if="step !== 'name'"
                  @click="goPrevStep"
                  variant="link"
                  class="mr-2"
                  >Назад</b-button
                >
                <b-button
                  @click="confirmStep"
                  variant="primary"
                  class="col-12 col-md-6"
                  size="lg"
                >
                  Продовжити
                </b-button>
              </div>
            </b-overlay>
          </b-card>
        </div>
        <div class="col-12 col-md-6">
          <div class="welcome__illustration">
            <img src="@/assets/img/contacts.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stepOne from "./steps/step-one.vue";
import stepTwo from "./steps/step-two.vue";
import stepThree from "./steps/step-three-final.vue";
export default {
  components: {
    stepOne,
    stepTwo,
    stepThree,
  },
  data() {
    return {
      isLoading: false,
      step: "name",
      steps: [
        {
          id: "name",
          title: "Контактні дані",
        },
        {
          id: "credentials",
          title: "Дані для входу",
        },
      ],
      new_user: {},
    };
  },
  computed: {
    currentStep() {
      let step = {};
      step = this.steps.find((el) => {
        return el.id == this.step;
      });

      return step;
    },
    currentStepIndex() {
      let index = this.steps.findIndex((el) => {
        return el.id == this.step;
      });
      return index;
    },
    nextStep() {
      let step = null;
      let index = this.steps.findIndex((el) => {
        return el.id == this.currentStep.id;
      });

      if (index + 1 < this.steps.length) {
        step = this.steps[index + 1];
      }

      return step;
    },
    prevStep() {
      let step = null;
      let index = this.steps.findIndex((el) => {
        return el.id == this.currentStep.id;
      });

      if (index + 1 <= this.steps.length) {
        step = this.steps[index - 1];
      }

      return step;
    },
  },

  methods: {
    async finalizeOnboarding() {
      this.isLoading = true;
      let user = this.new_user;
      user["role"] = "user";
      user["activated"] = true;
      console.log(user);
      let result = await this.$api
        .post("/user/invite/", user)
        .then((data) => {
          return data.data;
        })
        .catch((error) => {
          return error;
        });
      this.isLoading = false;
      if (result.success || result.code == "success") {
        this.step = "success";
      }
      if (result.success == false) {
        if (result.error.error.code == "auth/email-already-exists") {
          this.$toast.error("Користувач з такою поштою вже існує");
        }
      }
    },
    confirmStep() {
      this.$refs[this.step].confirm();
    },
    checkStep(val) {
      if (val.valid == false) {
        this.$toast.error("Всі поля обовʼязкові ");
      }
      if (val.valid == true && this.currentStepIndex < 2) {
        let prevData = this.new_user;
        let newData = val.data;
        this.new_user = { ...prevData, ...newData };
        if (this.currentStepIndex < 1) {
          this.goNextStep();
        } else {
          this.finalizeOnboarding();
        }
      }
    },
    goPrevStep() {
      this.step = this.prevStep.id;
    },
    goNextStep() {
      this.step = this.nextStep.id;
    },
  },
};
</script>

<style lang="scss" scoped>
.welcome {
  padding-top: 100px;
  min-height: 100vh;
  background: var(--primary-color);
  &__text {
    color: #fff;
    p {
      &:not(.first) {
        opacity: 0.7;
      }
    }
    .first {
      font-size: 24px;
      font-weight: 300;
      margin-bottom: 10px;
      line-height: 1.2;
      strong {
        display: block;
        color: var(--secondary-color);
      }
    }
  }
  &__step-info {
    color: #999;
    margin-bottom: 6px;
  }
  &__illustration {
    padding: 30px 90px;
    img {
      max-width: 100%;
    }
  }
}
</style>
